import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { WhatsappCampaignDataService } from '../../service/whatsapp-campaign-data.service';
import { catchError, tap } from 'rxjs/operators';

@Component({
    templateUrl: './whatsapp-campaign-setting.component.html',
    styleUrls: ['./whatsapp-campaign-setting.component.scss']
})
export class WhatsappCampaignSettingDialogComponent implements OnInit {

    form: FormGroup;
    buttonLoading = false;

    messages$ = this.whatsappCampaignDataService.messages$;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { mode: string, setting: any },
        public dialogRef: MatDialogRef<WhatsappCampaignSettingDialogComponent>,
        private whatsappCampaignDataService: WhatsappCampaignDataService
    ) { }

    ngOnInit() {
        this.formInit();
    }

    onCloseDialog(event?: Event, refresh = false) {
        this.dialogRef.close(refresh);
    }

    onSave() {
        this.buttonLoading = true;
        // To set "Save" button to disable (To prevent call API in multiple times when double click)
        this.form.setErrors({ 'invalid': true });

        const data = {
            ...this.form.value,
        };

        this.whatsappCampaignDataService.updateSetting(this.data.setting.id, data).pipe(
            tap(() => {
                this.buttonLoading = false;
                // To enable "Save" button after get response
                this.form.setErrors(null);
            }),
            catchError((error) => {
                this.buttonLoading = false;
                // To enable "Save" button after get response
                this.form.setErrors(null);
                throw error;
            })
        ).subscribe();
    }

    private formInit() {
        this.form = new FormGroup({
            batch_interval_minutes: new FormControl(this.data.setting.batch_interval_minutes, [Validators.required, Validators.min(5), Validators.max(1440)]),
            batch_send_limit: new FormControl(this.data.setting.batch_send_limit, [Validators.required, Validators.min(150), Validators.max(100000)])
        });
    }
}
